module.exports = __webpack_public_path__ + "9b7029a0f607613452be47dbbd5cedf9.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/facebook-active.png
 ** module id = 1552
 ** module chunks = 0
 **/